<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect :width="width" :height="height" rx="20" />
    <path class="call_fill_hoverEffect" d="M33.9816 26.2663C33.9816 25.9045 34.104 25.5427 34.104 25.0603C34.104 24.5779 34.104 24.2161 33.9816 23.8543L36.5523 21.804C36.7972 21.5628 36.7972 21.3216 36.6748 21.0804L34.2264 16.8593C34.104 16.7387 33.8592 16.6181 33.4919 16.7387L30.4314 17.9447C29.8193 17.4623 29.0848 17.1005 28.3503 16.7387L27.8607 13.603C27.9831 13.2412 27.6158 13 27.371 13H22.4743C22.2294 13 21.8622 13.2412 21.8622 13.4824L21.3725 16.7387C20.638 16.9799 20.0259 17.4623 19.2914 17.9447L16.3534 16.7387C15.9861 16.6181 15.7413 16.7387 15.4964 16.9799L13.048 21.201C12.9256 21.3216 13.048 21.6834 13.2929 21.9246L15.8636 23.8543C15.8636 24.2161 15.7412 24.5779 15.7412 25.0603C15.7412 25.5427 15.7412 25.9045 15.8636 26.2663L13.2929 28.3166C13.048 28.5578 13.048 28.799 13.1704 29.0402L15.6188 33.2613C15.7412 33.3819 15.986 33.5025 16.3533 33.3819L19.4138 32.1759C20.0259 32.6583 20.7604 33.0201 21.4949 33.3819L21.9845 36.5176C21.9845 36.7588 22.2294 37 22.5966 37H27.4934C27.7382 37 28.1054 36.7587 28.1054 36.5176L28.5951 33.3819C29.3296 33.0201 30.0641 32.6583 30.6762 32.1759L33.7367 33.3819C33.9816 33.5025 34.3488 33.3819 34.4712 33.1407L36.9196 28.9196C37.042 28.6784 37.042 28.3166 36.7971 28.196L33.9816 26.2663ZM24.9226 29.2814C22.5967 29.2814 20.638 27.3517 20.638 25.0603C20.638 22.7688 22.5967 20.8392 24.9226 20.8392C27.2486 20.8392 29.2073 22.7688 29.2073 25.0603C29.2073 27.3517 27.2486 29.2814 24.9226 29.2814Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.callIcon }
  },
  name: "IconCallSettings"
}
</script>

<style scoped>
rect{
    fill: var(--backgroundColor);
}
</style>
